import { useState } from "react";

import { exportBudgets } from "../../../api/fetchBudget";
import type { IBudgetKanbanFilters } from "../../../models/budget";

export const useBudgetExport = (filters: IBudgetKanbanFilters) => {
    const [isExporting, setIsExporting] = useState(false);

    const handleExport = async () => {
        setIsExporting(true);

        try {
            const { errorMessage } = await exportBudgets(filters);
            if (errorMessage) throw new Error(errorMessage);
        } catch (error) {
            console.error(`Erro ao exportar orçamentos: ${error}`);
        } finally {
            setIsExporting(false);
        }
    };

    return { isExporting, handleExport };
}